module.exports = __webpack_public_path__ + "static/media/1.226f73c8.png";